import React from 'react';

const TechStrip = () => {
  const technologies = [
    { name: 'C++', category: 'Languages', icon: 'fas fa-code' },
    { name: 'C#', category: 'Languages', icon: 'fas fa-code' },
    { name: 'Python', category: 'Languages', icon: 'fab fa-python' },
    { name: 'JavaScript', category: 'Languages', icon: 'fab fa-js-square' },
    { name: 'TypeScript', category: 'Languages', icon: 'fab fa-js-square' },
    { name: 'Kotlin', category: 'Languages', icon: 'fas fa-code' },
    { name: 'Swift', category: 'Languages', icon: 'fas fa-code' },
    { name: 'Unity', category: 'Frameworks & Engines', icon: 'fas fa-gamepad' },
    { name: 'Unreal Engine', category: 'Frameworks & Engines', icon: 'fas fa-cube' },
    { name: 'React', category: 'Frameworks & Engines', icon: 'fab fa-react' },
    { name: 'Next.js', category: 'Frameworks & Engines', icon: 'fas fa-layer-group' },
    { name: 'Django', category: 'Frameworks & Engines', icon: 'fas fa-server' },
    { name: 'TensorFlow', category: 'AI & ML', icon: 'fas fa-network-wired' },
    { name: 'OpenCV', category: 'AI & ML', icon: 'fas fa-eye' },
    { name: 'Hugging Face', category: 'AI & ML', icon: 'fas fa-robot' },
    { name: 'AWS', category: 'Infrastructure', icon: 'fab fa-aws' },
    { name: 'Docker', category: 'Infrastructure', icon: 'fab fa-docker' },
    { name: 'CI/CD Pipelines', category: 'Infrastructure', icon: 'fas fa-cogs' }
  ];

  return (
    <div className="tech-strip">
      <div className="container">
        <h2 className="section-title">Technology Stack</h2>
        <div className="tech-grid">
          {technologies.map((tech, i) => (
            <div key={i} className="tech-item">
              <div className="tech-logo">
                <i className={`${tech.icon} tech-icon`}></i>
              </div>
              <span className="tech-name">{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechStrip;
